import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  UpdateStatus,
} from "../../../../../../../features/admin/website/aboutus/ourStory/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const ourStory = useSelector((state) => state?.website?.ourStory);

  console.log(ourStory, "successSpeaks");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = ourStory?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: ourStory?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(UpdateStatus(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    ourStory,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
